import '../layout/app-legacy';
import utilities from 'components/utilities';
import modal from 'components/modal';
import 'jquery-flexslider';
import 'jquery-infinite-scroll';

export default (function () {
    function bindEmbedSizeUpdates(jqEvent) {
        // cache needed vars
        let embedWidthInputABC = $('#embed-width'),
            embedWidth = embedWidthInputABC.val(),
            embedPreview = $('#embed-preview'),
            embedIframe = $('iframe', embedPreview),
            embedIframeSrc = embedIframe.attr('data-url'),
            embedIframeNewSrc = utilities.updateQueryStringParameter(embedIframeSrc, 'width', embedWidth),
            widgetDiv = $('.portfolium-entry-widget'),
            embedCode = $('#embed-code');
        // update iFrame attributes

        widgetDiv.attr('data-width', embedWidth);
        embedIframe.css('width', embedWidth);
        embedIframe.attr('width', embedWidth);
        embedIframe.attr('data-url', embedIframeNewSrc);
        embedIframe.attr('src', embedIframeNewSrc);
        embedCode.val(embedCode.val().replace(/data-width="([0-9]+)"/, 'data-width="' + embedWidth + '"'));
    }

    // bind the listener for textbox updates for the entry embed width
    $(document).on('change', '#embed-width', bindEmbedSizeUpdates);
}());
